import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { workoutExecutionStore } from '@features/workout/execution/workoutExecutionStore'
import { ExerciseInWorkout } from '@entities/exercise'
import { useParams } from 'react-router'
import { useQueryParam } from '@shared/hooks/useQueryParams'
import { WorkoutType } from '@shared/hooks/trainingsNavigation/base'
import { useIonRouter, UseIonRouterResult } from '@ionic/react'
import { ROUTES } from '@shared/constants/routes'
import { LocalStorageKeys } from '@shared/constants/LocalStorageKeys'
import { WorkoutExecutionFlow } from '@pages/exercise/ui/WorkoutExecutionFlow'

export const ExercisePage = observer(() => {
	const workoutType: WorkoutType | undefined = useQueryParam('workout_type') as
		| WorkoutType
		| undefined
	const { exerciseOrder, trainingID } = useParams<{ exerciseOrder: string; trainingID: string }>()
	const exercise: ExerciseInWorkout | null =
		workoutExecutionStore.getExerciseByOrder(+exerciseOrder)
	const nav: UseIonRouterResult = useIonRouter()
	const isPastLastExercise = +exerciseOrder > workoutExecutionStore.exercisesAmount

	useEffect(() => {
		if (!isPastLastExercise) {
			return
		}

		const redirectURL: string | null = localStorage.getItem(LocalStorageKeys.workoutRedirectURL)
		nav.push(redirectURL || ROUTES.overall.main)
	}, [isPastLastExercise, nav])

	if (isPastLastExercise || !exercise || !workoutType) {
		return
	}

	return (
		<WorkoutExecutionFlow
			workoutType={workoutType}
			exercise={exercise}
			exerciseOrder={+exerciseOrder || -1}
			trainingID={+trainingID || -1}
		/>
	)
})
